import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import TransactionTypes from '../types/TransactionType';
import { GridFilters, initialStateList } from './GridFiltersReducer';
import { upcomingPaymentsInitialState } from '../../modules/upcoming-payments/upcomingPayments.initialState';
import { UpcomingPaymentsActionTypes } from '../../modules/upcoming-payments/upcomingPayments.actionTypes';

const initialState = {
  cashIn: { ...initialStateList },
  cashOut: { ...initialStateList },
  allTransactions: { ...initialStateList },
  upcomingPayments: { ...upcomingPaymentsInitialState },
  refund: { ...initialStateList },
  chargeback: { ...initialStateList },
  balanceReport: { ...initialStateList },
  balanceWalletReport: { ...initialStateList },
  availableCountries: [],
  refundDetails: {},
};

export const Transactions = handleActions(
  {
    ...GridFilters,
    [TransactionTypes.actions.fetchTransactionsFiltersSuccess]: (state, { payload: { availableCountries } }) => {
      return { ...state, availableCountries };
    },
    [TransactionTypes.actions.fetchRefundDetailsSuccess]: (state, { payload: { refundDetails } }) => {
      return { ...state, refundDetails };
    },
    [TransactionTypes.actions.resetList]: (state, { payload: { listName } }) => {
      return {
        ...state,
        [listName]: { ...initialStateList },
      };
    },
    [UpcomingPaymentsActionTypes.fetchUpcomingPaymentsTotalsSuccess]: (state, { payload }) => {
      return {
        ...state,
        upcomingPayments: {
          ...state.upcomingPayments,
          totals: payload.map((total) => ({ currency: total.currency, amount: total.totalAmount })),
        },
      };
    },
  },
  initialState
);

const getTransactions = (state) => state.Transactions;

export const getTransactionCountries = (state) => state.Transactions.availableCountries || [];

export const getTransactionList = (state, list) => {
  const transactions = getTransactions(state);
  return transactions[list] || undefined;
};

export const getRefundDetails = createSelector(getTransactions, (transaction) => transaction.refundDetails);
